/**
 * @packageDocumentation
 * @module index
 */

import * as color from './index.esm.js';

export default Object.assign(color.default, color);
